import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";

@Component({
  selector: "app-delete-button",
  templateUrl: "./delete-button.component.html",
  styleUrl: "./delete-button.component.scss",
  imports: [UiKitModule],
  standalone: true,
})
export class DeleteButtonComponent {
  @Input({ required: true }) disabled!: boolean;
  @Output() delete = new EventEmitter();

  protected readonly tooltipTextDeleteItem: string = $localize`:@@floorplan.button.deleteItem:Element löschen`;

  protected onClickDelete() {
    this.delete.emit();
  }
}
